import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/main.scss'; // Importa el archivo de estilos globales
import router from './router';
import store from './store';

import {initSuperTokens} from "@/supertokens";
import { register } from 'swiper/element/bundle';
import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';

import CookieConsentComponent from '@/components/core/CookieConsentComponent/CookieConsentComponent.vue';
import { useGTM } from '@/helpers/initGTM';

initSuperTokens();
register();

export const app = createApp(App);

app.component('vue-cookie-accept-decline', VueCookieAcceptDecline);
app.use(router);
app.use(store);

if (localStorage.getItem('cookiesAccepted') === 'true') {
  useGTM(app);
}

app.mount('#app');


// Mount cookie consent banner globally
const mountCookieConsent = () => {
  const consentContainer = document.createElement('div')
  document.body.appendChild(consentContainer)
  createApp(CookieConsentComponent).mount(consentContainer)
}

mountCookieConsent()
